import { ReservationCheckbox } from "./types";

export const getCheckboxOptions = (cboxes: ReservationCheckbox[]) => {
  const isChecked = cboxes.filter((cb) => cb.checked);
  if (isChecked.length === 1)
    return {
      [isChecked[0].id]: isChecked[0].value,
    };
  return {};
};
